module.exports = __webpack_public_path__ + "img/logo.0712c431.svg";